import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const HMACContainer = styled.div`
  display: flex;
  gap: var(--space-150);
  align-items: center;
`

export const HMACKeyLabel = styled.div`
  font-size: var(--font-size-300);
  font-weight: var(--font-weight-medium);
  color: var(--text-primary);
`
